angular.module('leanlaw').factory('commonFilterService', ['$rootScope', 'userService', function ($rootScope, userService) {
  let _me;
  userService.me().then(me => {
    _me = me;
  });
  let _state = {};
  function setFilterState(state) {
    _state = state;
    $rootScope.$broadcast("commonFilterService-statechanged", state);
  }
  return {
    getFilterState() {
      return _state;
    },
    setFilterState
  };
}]);